module.exports = __webpack_public_path__ + "img/192.7e7505a1.jpg";